"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.change_password_thunk = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var local_storage_names_1 = require("../../../constants/local_storage_names");
var main_1 = require("../main");
var user_1 = require("../user");
var change_password_1 = require("../../../api/calls/user/change_password");
var get_user_1 = require("../../../api/calls/user/get_user");
exports.change_password_thunk = (0, toolkit_1.createAsyncThunk)("user/change_password_thunk", function (args, _a) {
    var dispatch = _a.dispatch, getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var state, userState, user, isLoading, new_password, changePasswordResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    state = getState();
                    userState = state.userState;
                    user = userState.user, isLoading = userState.isLoading;
                    new_password = args.new_password;
                    return [4 /*yield*/, (0, change_password_1.change_password)({
                            new_password: new_password,
                        })];
                case 1:
                    changePasswordResponse = _b.sent();
                    // Indicate that the API is done being called.
                    // await dispatch(setIsLoading(false));
                    // Handle the response.
                    if (changePasswordResponse.success) {
                        dispatch((0, user_1.setIsLoading)(true));
                        (0, get_user_1.get_user)({
                            user_entity_id: changePasswordResponse.content.user.entity_id,
                        }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                            var usr;
                            return __generator(this, function (_a) {
                                dispatch((0, user_1.setIsLoading)(false));
                                if (response.success) {
                                    usr = {
                                        user: __assign(__assign({}, changePasswordResponse.content.user), response.content),
                                        token: changePasswordResponse.content.token,
                                    };
                                    dispatch((0, user_1.setUser)(usr.user));
                                    dispatch((0, user_1.setUserToken)(usr.token));
                                    if (localStorage.getItem(local_storage_names_1.USER_LOCAL_STORAGE)) {
                                        localStorage.setItem(local_storage_names_1.USER_LOCAL_STORAGE, JSON.stringify(usr));
                                    }
                                    dispatch((0, main_1.setMessageModal)({
                                        title: "Success",
                                        messages: ["Your password has been changed successfully!"],
                                    }));
                                }
                                else {
                                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong while retrieving user's details!", messages: [response.message] }));
                                }
                                return [2 /*return*/];
                            });
                        }); });
                    }
                    else {
                        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [changePasswordResponse.message] }));
                    }
                    return [2 /*return*/, changePasswordResponse];
            }
        });
    });
});
